// Reiter — cart drawer cross-sell colour swatches ("Dazu passend").
//
// The recommendations themselves are now rendered server-side inline by
// snippets/reiter-cart-recommendations.liquid (data-driven vase + colour ranking) and
// kept fresh by Horizon's hydration-mode morph on every cart change — so there is no
// fetching here anymore. This script only handles the in-row colour picker: clicking a
// swatch repoints the add-to-cart form at that colour's variant and swaps the thumbnail.
//
// Listeners are delegated on the document so they survive the drawer being morphed
// (the markup is re-rendered from scratch on each cart mutation; no per-node re-init).

(function () {
  function selectSwatch(swatch) {
    var row = swatch.closest('.reiter-reco');
    if (!row) return;

    var variantId = swatch.getAttribute('data-variant-id');
    var img = swatch.getAttribute('data-img');
    var color = swatch.getAttribute('data-color');

    // Repoint the add-to-cart form at the chosen variant.
    if (variantId) {
      var input = row.querySelector('input[name="id"]');
      if (input) input.value = variantId;
    }

    // Swap the thumbnail to the chosen colour's image.
    if (img) {
      var thumb = row.querySelector('.reiter-reco__img img');
      if (thumb) thumb.src = img;
    }

    // Reflect the chosen colour name in the meta line.
    if (color != null) {
      var label = row.querySelector('.reiter-reco__color-name');
      if (label) label.textContent = color;
    }

    // Move the active state.
    var swatches = row.querySelectorAll('.reiter-reco__swatch');
    for (var i = 0; i < swatches.length; i++) {
      var s = swatches[i];
      var active = s === swatch;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest && e.target.closest('.reiter-reco__swatch');
    if (!swatch) return;
    e.preventDefault();
    selectSwatch(swatch);
  });
})();
